
<template>
    <div class="fill-height">
        <v-btn
            v-if="item.hassub == false"                         
            flat                        
            v-bind:to="item.link"
            v-on:click=""
            >
            <v-icon left dark>{{ item.icon }}</v-icon>
            {{ item.title }}
        </v-btn>  
        <v-menu 
            offset-y
            bottom   
            v-else      
        >
         
            <v-btn

                flat            
                slot="activator"
                v-bind:to="item.link"
                v-on:click=""
                >
                <v-icon left dark>{{ item.icon }}</v-icon>
                {{ item.title }}
            </v-btn>                    
            <v-list >
                <v-list-tile                                 
                        v-for="(sub,index) in item.sub"                     
                        v-bind:key="index"
                        v-bind:to="sub.link">
                    <v-list-tile-title class="">
                        {{ sub.title }}
                    </v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>                 
    </div>                                                       
</template>
<script>



export default {   
    props:[
        'item'
    ],   
    data() {
        return {            
          
        };
    },
    computed: {
       
        hasSub: function(){            
            return this.item.sub.length
        },
    },
    methods: {
        
        
        
    }
    
}
</script>